export const mediaGalleryStyles = {
  grid: "my-2 grid grid-cols-1 gap-3 sm:grid-cols-2",
  item: "overflow-hidden rounded-2xl border border-border shadow-sm",
  embedWrapper: "relative aspect-video w-full",
  embedFrame: "absolute inset-0 h-full w-full",
  image: "block h-auto w-full",
  caption: "px-3 py-2 text-xs text-subtle",
};
